/**
 * Project page, the back — what keeps it standing, at night: the stack in a
 * terminal, the key numbers, the total of features and every module with
 * its features, then the built-in quality.
 *
 * Played like a build log: the numbers rise and count, the total slides in
 * and drifts, every module lifts its card, fills its bar and prints its
 * lines one by one while each bullet pops; the quality pills land last.
 * The markup is the server's (templates/site/sections/project/back.html.twig).
 *
 * @module sections/project/back
 */

import { REDUCED_MOTION } from '../../config.js';
import { $$ } from '../../lib/dom.js';
import { ScrollTrigger, gsap } from '../../lib/gsap.js';

export function animate() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('.case-stats').forEach((grid) => {
        gsap.from(grid.children, {
            opacity: 0,
            yPercent: 35,
            duration: 0.8,
            ease: 'power3.out',
            stagger: { each: 0.08, grid: 'auto', from: 'start' },
            scrollTrigger: { trigger: grid, start: 'top 86%', once: true },
        });
    });

    $$('.case-total').forEach((total) => {
        gsap.from(total.children, {
            xPercent: -14,
            opacity: 0,
            duration: 1.1,
            ease: 'power4.out',
            stagger: 0.12,
            scrollTrigger: { trigger: total, start: 'top 86%', once: true },
        });

        gsap.fromTo(
            total,
            { x: 0 },
            {
                x: () => -window.innerWidth * 0.04,
                ease: 'none',
                scrollTrigger: { trigger: total, start: 'top bottom', end: 'bottom top', scrub: true },
            },
        );
    });

    const groups = $$('[data-group]');

    if (groups.length) {
        gsap.set(groups, { opacity: 0, y: 48 });

        ScrollTrigger.batch(groups, {
            start: 'top 90%',
            once: true,
            onEnter: (batch) => {
                batch.forEach((group, index) => {
                    const lines = group.querySelectorAll('li');

                    gsap.timeline({ delay: index * 0.12 })
                        .to(group, { opacity: 1, y: 0, duration: 0.75, ease: 'power3.out' }, 0)
                        .from(
                            group.querySelector('.case-group__title span'),
                            { yPercent: 110, duration: 0.6, ease: 'power3.out' },
                            0.15,
                        )
                        .from(
                            group.querySelector('.case-group__bar i'),
                            { scaleX: 0, duration: 0.9, ease: 'power3.out' },
                            0.25,
                        )
                        .from(lines, { opacity: 0, x: -12, duration: 0.3, stagger: 0.035, ease: 'power2.out' }, 0.35)
                        .fromTo(
                            lines,
                            { '--pop': 0 },
                            { '--pop': 1, duration: 0.4, stagger: 0.035, ease: 'back.out(3)' },
                            0.4,
                        );
                });
            },
        });
    }

    $$('.case-quality').forEach((quality) => {
        gsap.from(quality.querySelectorAll('.pill'), {
            opacity: 0,
            scale: 0.8,
            y: 10,
            duration: 0.5,
            ease: 'back.out(2)',
            stagger: 0.05,
            scrollTrigger: { trigger: quality, start: 'top 90%', once: true },
        });
    });
}
